<app-shop-content-block [contentId]="'balance-intro'"></app-shop-content-block>
<div>
  <iframe [src]="balanceCheckUrl"></iframe>
</div>
